import React from 'react';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';
import Call from '../../components/Call';

const Constitution= props => (
  <Layout bodyClass="page-contact">
    <SEO title="Consultation" />
    <div className="intro intro-small">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h1>Our Constitution</h1>
          </div>
        </div>
      </div>
    </div>
    <div className="container">
      <div className="row">
        <div className="col-12">
          <Call button={false} />
        </div>


        <div className="col-12 pt-5 pb-4">
        This is a very rough draft of our constitution. <br></br>
        There's still a lot of work to do but it does provide the most complete picture of our vision so far. <br></br>Feedback welcome!

     <a href="https://oneaction.nz/Downloads/OneAction%20-%20Constitution%20v2.1%20-%20Published.pdf" target="_blank">
         <br></br> OneAction - Constitution v2.1 - Published.pdf</a>

        </div>
       
      </div> 
    </div>
  </Layout>
);

export default Constitution;
